import { Autocomplete, TextField } from "@mui/material";
import NewAppointmentProps from "../interface/newAppointmentProps";
import { coachingTypes } from "./coachingTypes";
import { NewAppointmentContext } from "../context/newAppointmentContext";
import React from "react";

const CoachingTypeInput = (): React.JSX.Element => {
  const {
    newAppointment,
    setNewAppointment,
  }: {
    newAppointment: NewAppointmentProps;
    setNewAppointment: (newAppointment: NewAppointmentProps) => void;
  } = React.useContext(NewAppointmentContext);

  return (
    <Autocomplete
      disablePortal
      id="coachingTypeInput"
      options={coachingTypes}
      value={newAppointment.type}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      onChange={(_event, option) => {
        setNewAppointment({ ...newAppointment, type: option });
      }}
      renderInput={(params) => (
        <TextField
          required
          error={!newAppointment.type}
          color="success"
          {...params}
          label="Art"
        />
      )}
    />
  );
};

export default CoachingTypeInput;
